import deburr from "lodash.deburr";

interface SinglePageURLParameters {
  orgId: string;
  channelId: string;
  spaceId: string;
}

const DEFAULT_URL_ATTRIBUTES = { orgId: "", channelId: "", spaceId: "" };

export const getParametersFromUrl = (url: string): SinglePageURLParameters => {
  let attributes: SinglePageURLParameters = DEFAULT_URL_ATTRIBUTES;
  if (url && url.includes("/view/")) {
    const removeFirstPart = url.substr(url.indexOf("/view/") + 6);
    if (removeFirstPart.includes("/")) {
      const params = removeFirstPart.split("/");
      attributes = {
        orgId: params[0],
        spaceId: params[1],
        channelId: params[2],
      };

      return attributes;
    }
  }

  return DEFAULT_URL_ATTRIBUTES;
};

export const encodeString = (str: string): string => {
  let output = "";
  if (str) {
    output = str.trim().toLocaleLowerCase().replace(/ /g, "-");
    return deburr(output);
  }
  return output;
};
